import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles.css";
var SECTIONS = [
    {
        label: "Macarons",
        images: [
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_124351_1.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130708_1.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130708_2.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130708.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130709_1.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130709_2.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130709_3.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/macarons/IMG_20260512_130709.jpg",
        ],
    },
    {
        label: "Pies",
        images: [
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/pies/12351232.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/pies/IMG_20260512_130237_3.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/pies/IMG_20260512_130237_4.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/pies/IMG_20260512_130237.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/pies/Pies.jpg",
        ],
    },
    {
        label: "Cheesecakes",
        images: [
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/cakes/IMG_20260512_124349_1.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/cakes/IMG_20260512_124349_2.jpg",
        ],
    },
    {
        label: "More Treats",
        images: [
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/miscellaneous/IMG_20260512_160144.jpg",
            "https://confectioncobakery-assets-859780942726-us-east-2-an.s3.us-east-2.amazonaws.com/miscellaneous/IMG_20260512_160146.jpg",
        ],
    },
];
var TOTAL_IMAGES = SECTIONS.reduce(function (sum, s) { return sum + s.images.length; }, 0);
var THRESHOLD = 3;
export default function MyBakes() {
    useLayoutEffect(function () { window.scrollTo({ top: 0, behavior: "instant" }); }, []);
    var _a = useState(false), ready = _a[0], setReady = _a[1];
    var loadedCount = useRef(0);
    var handleLoad = function (e) {
        e.currentTarget.classList.add("loaded");
        loadedCount.current += 1;
        if (!ready && loadedCount.current >= Math.min(THRESHOLD, TOTAL_IMAGES)) {
            setReady(true);
        }
    };
    return (_jsxs("div", { className: "gallery-page".concat(ready ? " gallery-page--ready" : ""), children: [_jsxs("section", { className: "gallery-hero", children: [_jsx("span", { className: "gallery-eyebrow", children: "from my kitchen" }), _jsx("h1", { className: "gallery-heading", children: "My Bakes" }), _jsx("div", { className: "gallery-rule", "aria-hidden": "true" }), _jsx("p", { className: "gallery-subtext", children: "Macarons, pies, and everything in between \u2014 all made with the same love from scratch." })] }), _jsxs("section", { className: "gallery-canvas", children: [SECTIONS.map(function (_a) {
                        var label = _a.label, images = _a.images;
                        return (_jsxs("div", { className: "bakes-section", children: [_jsxs("div", { className: "bakes-section-header", children: [_jsx("span", { className: "bakes-section-label", children: label }), _jsx("div", { className: "bakes-section-rule", "aria-hidden": "true" })] }), _jsx("div", { className: "gallery-grid", children: images.map(function (src, i) { return (_jsx("div", { className: "gallery-item", children: _jsx("img", { src: src, alt: "".concat(label, " ").concat(i + 1), className: "gallery-img", loading: "lazy", onLoad: handleLoad }) }, i)); }) })] }, label));
                    }), _jsxs("div", { className: "gallery-cta-wrap", children: [_jsx("p", { className: "gallery-cta-text", children: "Ready to place an order?" }), _jsx(Link, { to: "/#order", className: "hero-cta", children: "Order Now" })] })] })] }));
}
